// Action Types
export const ACTIVITY_SESSION_CREATE_STARTED = 'ACTIVITY_SESSION_CREATE_STARTED';
export const ACTIVITY_SESSION_CREATE_COMPLETED = 'ACTIVITY_SESSION_CREATE_COMPLETED';
export const ACTIVITY_SESSION_CREATE_FAILED = 'ACTIVITY_SESSION_CREATE_FAILED';

export const ACTIVITY_SESSION_CLOSE_STARTED = 'ACTIVITY_SESSION_CLOSE_STARTED';
export const ACTIVITY_SESSION_CLOSE_COMPLETED = 'ACTIVITY_SESSION_CLOSE_COMPLETED';
export const ACTIVITY_SESSION_CLOSE_FAILED = 'ACTIVITY_SESSION_CLOSE_FAILED';

export const ACTIVITY_LOG_ADDED = 'ACTIVITY_LOG_ADDED';
export const ACTIVITY_LOG_FLUSH_STARTED = 'ACTIVITY_LOG_FLUSH_STARTED';
export const ACTIVITY_LOG_FLUSH_COMPLETED = 'ACTIVITY_LOG_FLUSH_COMPLETED';
export const ACTIVITY_LOG_FLUSH_FAILED = 'ACTIVITY_LOG_FLUSH_FAILED';

export const ACTIVITY_LOGS_FETCH_STARTED = 'ACTIVITY_LOGS_FETCH_STARTED';
export const ACTIVITY_LOGS_FETCH_COMPLETED = 'ACTIVITY_LOGS_FETCH_COMPLETED';
export const ACTIVITY_LOGS_FETCH_FAILED = 'ACTIVITY_LOGS_FETCH_FAILED';

// Interfaces
export interface ActivityLogEntry {
  routePath: string;
  routeName: string;
  routeParams?: string;
  actionType: ActionType;
  entityTypeId?: number;
  entityId?: number;
  timeOnPageMs?: number;
  visitedAt: string;
}

export type ActionType =
  | 'PAGE_VISIT'
  | 'MODAL_OPEN'
  | 'MODAL_CLOSE'
  | 'SLIDING_PANE_OPEN'
  | 'SLIDING_PANE_CLOSE'
  | 'MAP_INTERACTION'
  | 'FILTER_CHANGE';

export interface ActivitySession {
  sessionId: string;
  userId: number;
  platform: string;
  startedAt: string;
  endedAt?: string;
  ipAddress?: string;
  status: string;
}

export interface ActivityLogRecord {
  id: string;
  userId: number;
  userName: string;
  completeName: string;
  sessionId: string;
  platform: string;
  routePath: string;
  routeName: string;
  routeParams?: string;
  actionType: string;
  entityTypeId?: number;
  entityTypeName?: string;
  entityId?: number;
  timeOnPageMs?: number;
  visitedAt: string;
  ipAddress?: string;
}
